'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BcReactComponent = require('./components/BcReactComponent.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BcReactComponent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-bc-react-component/lib/index.js
// module id = 2
// module chunks = 1